import React, { useState } from "react"
import { FaUserMinus } from "react-icons/fa"
import { sendUnenrolUserProgram } from "../../../requesters/Backend/UserRequester"
import ConfirmActionModal from "./ConfirmActionModal"
import QuickAction from "./QuickAction"
import runUserAction from "./runUserAction"

function UnenrolModal({ baseUrl, refetch, userDetail: { id } }) {
  const [showModal, setShowModal] = useState(false)
  const handleToggleModal = () => setShowModal(!showModal)

  const handleUnenrolUser = () => runUserAction(sendUnenrolUserProgram(baseUrl, { user_id: id }), {
    successMessage: "Unenrol user from the program",
    fallbackError: "Could not unenrol this user",
    onSuccess: () => {
      setShowModal(false)
      refetch()
    }
  })

  return (
    <>
      <QuickAction danger icon={FaUserMinus} label="Unenrol User from the program" onClick={handleToggleModal} />
      <ConfirmActionModal
        confirmLabel="Yes"
        onConfirm={handleUnenrolUser}
        onHide={handleToggleModal}
        show={showModal}
        title="Unenrol user">
        <p>Are you sure?</p>
      </ConfirmActionModal>
    </>
  )
}

export default UnenrolModal
